import consts from "../consts"

const onlineModules = [
    { text: "Planning", value: "planning", requiredPerm: "admin:planning", hasLandingPage: true },
    { text: "Contrôle d'accès", value: "ctm", requiredPerm: "admin:ctm", hasLandingPage: true },
    { text: "Clients", value: "clients", requiredPerm: "admin:clients", hasLandingPage: true },
    { text: "Statistiques", value: "stats", requiredPerm: "admin:stats", hasLandingPage: true },
    { text: "Spa", value: "spa", requiredPerm: "admin:spa", hasLandingPage: true },
    { text: "Casiers", value: "lockers", requiredPerm: "admin:lockers", hasLandingPage: true },
    { text: "Backoffice", value: "front" },
    { text: "Gestion commerciale", requiredPerm: "admin:business", value: "business", hasLandingPage: true },
    { text: "Odéon", value: "odeon" },
    { text: "Activités périodiques", value: "activities", requiredPerm: "admin:activities", hasLandingPage: true },
    { text: "Devis", value: "quotations", requiredPerm: "admin:quotations", hasLandingPage: true },
    { text: "Bornes", value: "kiosks", requiredPerm: "admin:kiosks", hasLandingPage: true },
    { text: 'Affichage centralisé', value: 'displayland', requiredPerm: "admin:displayland", hasLandingPage: true }
]

const bookingTerminalPlanningTypes = [
    { text: "Créneaux groupés par activité", value: consts.BOOKING_TERMINAL_PLANNING_TYPES.GROUPED_BY_ACTIVITY },
    { text: "Créneaux mélangés", value: consts.BOOKING_TERMINAL_PLANNING_TYPES.MIXED_ACTIVITIES },
]

const billingModeTypes = [
    { text: "Au créneau", value: consts.BILLING_MODE_TYPES.SESSION, icon: "mdi-calendar" },
    { text: "Horaire", value: consts.BILLING_MODE_TYPES.TIME, icon: "mdi-timeline-clock" },
    { text: "Horaire au prorata", value: consts.BILLING_MODE_TYPES.PRORATED_TIME, icon: "mdi-clock-alert" },

]

const billImageOptions = [
    { text: 'Ne rien afficher', value: consts.BILL_IMAGE_OPTION.NONE },
    { text: "Utiliser le logo", value: consts.BILL_IMAGE_OPTION.LOGO },
    { text: "Utiliser le fond", value: consts.BILL_IMAGE_OPTION.BACKGROUND },
]

const sageExportTypes = [
    { text: 'PNM', value: consts.SAGE_EXPORT_TYPE.SAGE_EXPORT_PNM },
    { text: 'Excel', value: consts.SAGE_EXPORT_TYPE.SAGE_EXPORT_EXCEL },
    { text: 'CSV', value: consts.SAGE_EXPORT_TYPE.SAGE_EXPORT_CSV }
]

const actionHistoryTypes = [
    {value: consts.ACTION_TYPES.SUBSCRIPTION_CREATED, text: "Création de l'abonnement", icon: "mdi-card-plus"},
    {value: consts.ACTION_TYPES.SUBSCRIPTION_RELOADED, text: "Réactivation de l'abonnement", icon: "mdi-reload"},
    {value: consts.ACTION_TYPES.SUBSCRIPTION_AUTO_RENEWED, text: "Renouvellement automatique de l'abonnement", icon: "mdi-autorenew"},
    {value: consts.ACTION_TYPES.SUBSCRIPTION_CREDITED, text: "Crédit manuel de l'abonnement", icon: "mdi-plus-minus-variant"},
    {value: consts.ACTION_TYPES.SUBSCRIPTION_DEBITED, text: "Débit manuel de l'abonnement", icon: "mdi-plus-minus-variant"},
    {value: consts.ACTION_TYPES.SUBSCRIPTION_UPDATED, text: "Modification de l'abonnement", icon: "mdi-pencil"},
    {value: consts.ACTION_TYPES.SUBSCRIPTION_STOPPED, text: "Arrêt de l'abonnement", icon: "mdi-stop"},
    {value: consts.ACTION_TYPES.SUBSCRIPTION_PAUSED, text: "Pause de l'abonnement", icon: "mdi-pause"},
    {value: consts.ACTION_TYPES.SUBSCRIPTION_UNPAUSED, text: "Reprise de l'abonnement", icon: "mdi-play"},
    {value:  consts.ACTION_TYPES.SUBSCRIPTION_TRANSFERED, text: "Transfert de l'abonnement", icon: "mdi-swap-horizontal"},
    {value: consts.ACTION_TYPES.SUBSCRIPTION_EXTENDED, text: "Extension de l'abonnement", icon: "mdi-calendar-plus"},
    {value: consts.ACTION_TYPES.SUBSCRIPTION_REGROUPED, text: "Regroupement de l'abonnement", icon: "mdi-cards"},
    {value: consts.ACTION_TYPES.UNITS_RELOAD, text: "Rechargement d'unités", icon: "mdi-reload"},
    {value: consts.ACTION_TYPES.CAGNOTTE_RELOAD, text: "Rechargement de la cagnotte", icon: "mdi-reload"},
    {value: consts.ACTION_TYPES.COLLECTABLE_VOUCHER_GENERATED, text: "Génération d'un bon d'échange", icon: "mdi-ticket-confirmation"},
    {value: consts.ACTION_TYPES.GIFT_VOUCHER_GENERATED, text: "Génération d'un bon cadeau", icon: "mdi-gift"},
    {value: consts.ACTION_TYPES.ACV_GENERATED, text: "Génération du bon d'accès", icon: "mdi-ticket-confirmation"},
    {value: consts.ACTION_TYPES.SPA_BOOKING_ADDED, text: "Réservation SPA", icon: "mdi-spa"},
    {value: consts.ACTION_TYPES.SPA_BOOKING_MOVED, text: "Déplacement d'une réservation SPA", icon: "mdi-calendar-arrow-right"},
    {value: consts.ACTION_TYPES.SPA_BOOKING_REMOVED, text: "Annulation d'une réservation SPA", icon: "mdi-calendar-remove"},
    {value: consts.ACTION_TYPES.SPA_BOOKING_DELETED, text: "Suppression d'une réservation SPA", icon: "mdi-delete"},
    {value: consts.ACTION_TYPES.CLUB_MEMBER_ADDED, text: "Ajout d'un membre", icon: "mdi-account-plus"},
    {value: consts.ACTION_TYPES.CLUB_MEMBER_REMOVED, text: "Suppression d'un membre", icon: "mdi-account-remove"},
    {value: consts.ACTION_TYPES.CLUB_MEMBER_RENEWED, text: "Renouvellement d'un membre", icon: "mdi-account-check"},
    {value: consts.ACTION_TYPES.CLUB_MEMBER_REMOVED_WITH_UNRETURNED_CARD, text: "Suppression d'un membre sans carte", icon: "mdi-account-remove"},
    {value: consts.ACTION_TYPES.VOUCHER_USED, text: "Utilisation d'un bon", icon: "mdi-ticket-confirmation"},
    {value: consts.ACTION_TYPES.NOTIFY_SUBSCRIPTION, text: "Notification de l'état d'un abonnement", icon: "mdi-bell"},
    {value: consts.ACTION_TYPES.CLIENTS_MERGED, text: "Fusion de clients", icon: "mdi-account-group"}
]

export function actionType(value) {
    return actionHistoryTypes.find(ah => ah.value === value)
}

export { onlineModules, bookingTerminalPlanningTypes, billingModeTypes, billImageOptions, sageExportTypes, actionHistoryTypes }
